import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('roulettes-fields', storeModule.createStoreModule('roulettes-fields'))
